import React from 'react';
import TextInput from '../../UI/Form/TextInput';
import TextArea from '../../UI/Form/TextArea';
import JsonSelect from '../../UI/Form/JsonSelect';

const ExtensionForm = ({form_state, onUpdateForm}) => {
  return (
    <div className=" max-h-[85dvh] h-full overflow-y-auto border border-gray-200 rounded-md py-4 px-5 w-[97%] m-3 flex flex-col gap-3  ">
      {/* Title */}
      <TextInput
        title={'Name'}
        current_data={form_state?.name}
        placeholder={'Extension Name'}
        type={'text'}
        update_data={data => onUpdateForm({key: 'name', value: data})}
        isRequired={true}
      />
      {/* Domain */}
      <TextInput
        title={'Domain'}
        current_data={form_state?.domain}
        placeholder={'Extension Domain'}
        type={'text'}
        update_data={data => onUpdateForm({key: 'domain', value: data})}
      />
      {/* configs // json data  */}

      <JsonSelect
        title={'Configs'}
        current_data={form_state?.configs}
        update_data={data => onUpdateForm({key: 'configs', value: data})}
      />
    </div>
  );
};

export default ExtensionForm;
